import { animate, style, transition, trigger } from '@angular/animations';

export const fadeInAnimation =
  trigger(
    'fadeInAnimation', [
    transition(':enter', [
      style({ opacity: 0, transform: 'scale(.95)' }),
      animate('300ms 100ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
    ])
  ]);
